import state from './modulePlacesState.js'
import mutations from './modulePlacesMutations.js'
import actions from './modulePlacesActions.js'
import getters from './modulePlacesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
